// extracted by mini-css-extract-plugin
export default {"root":"Group_root__hEMsM"};